<tcc-mono-dialog-layout
  [title]="'Diergegevens ' + displayId"
  [displayBottomButtons]="true"
  saveText="Opnieuw zoeken"
  (onSave)="searchAgain()"
>
  <div class="info-dialog">
    <div *ngIf="loading" class="loading-state ion-text-center ion-padding">
      <ion-spinner></ion-spinner>
      <p>RVO diergegevens ophalen...</p>
    </div>

    <div *ngIf="error && !loading" class="error-box ion-padding">{{ error }}</div>

    <ng-container *ngIf="animalData && !loading">
      <div class="search-summary">
        Gezocht op <strong>{{ countryCode }} {{ identificationNumber }}</strong>
      </div>

      <div class="action-links" *ngIf="animalData.ride?.id || animalData.animal?.id">
        <ion-button
          *ngIf="animalData.ride?.id"
          mode="ios"
          fill="outline"
          size="small"
          (click)="openRide()"
        >
          <fa-icon [icon]="['fal', 'truck-fast']" slot="start"></fa-icon>
          Naar rit {{ animalData.ride?.number }}
        </ion-button>
        <ion-button
          *ngIf="animalData.animal?.id"
          mode="ios"
          fill="outline"
          size="small"
          (click)="openErpAnimal()"
        >
          <fa-icon [icon]="['fal', 'cow']" slot="start"></fa-icon>
          Naar ERP-dier
        </ion-button>
      </div>

      <div *ngIf="animalData.rvo_error" class="rvo-error-box">
        <div class="error-title">RVO foutmelding</div>
        <div>{{ animalData.rvo_error }}</div>
      </div>

      <ng-container *ngIf="rvoAnimal as info">
        <div class="animal-card" [ngClass]="lifeStatusBannerClass(info)">
          <div class="animal-card__header">
            <div class="animal-card__main">
              <p class="animal-card__title">
                {{ speciesLabel(info.dierSoort) }}
                <span class="animal-card__id">{{ formatAnimalDisplayId(info.dierLandcode, info.dierLevensnummer) }}</span>
              </p>
              <p *ngIf="info.dierWerknummer" class="animal-card__meta">Werknummer {{ info.dierWerknummer }}</p>
              <p
                *ngIf="formatReplacedAnimalId(info.dierVervangenLandcode, info.dierVervangenLevensnummer, info.dierVervangenWerknummer) as replacedId"
                class="animal-card__replaced-id"
              >
                Vervangen nummer <span class="animal-card__replaced-id-value">{{ replacedId }}</span>
              </p>
            </div>
            <span
              *ngIf="lifeStatus(info) !== 'active'"
              class="life-status-badge"
              [ngClass]="animalLifeStatusClass(lifeStatus(info))"
            >
              {{ animalLifeStatusLabel(lifeStatus(info), info.dierRedenEinde) }}
            </span>
          </div>

          <dl class="animal-card__meta-grid">
            <div>
              <dt>Geboorte</dt>
              <dd>{{ formatRvoDisplayDate(info.geboorteDatum) || '—' }}</dd>
            </div>
            <div *ngIf="formatRvoDisplayDate(info.dierEinddatum)">
              <dt>Einddatum</dt>
              <dd>{{ formatRvoDisplayDate(info.dierEinddatum) }}</dd>
            </div>
            <div>
              <dt>Geslacht</dt>
              <dd>{{ genderLabel(info.dierGeslacht) }}</dd>
            </div>
            <div *ngIf="info.dierHaarkleur?.trim()">
              <dt>Kleur</dt>
              <dd>{{ info.dierHaarkleur }}</dd>
            </div>
            <div *ngIf="rvoAgeDays(info.geboorteDatum) as ageDays">
              <dt>Leeftijd</dt>
              <dd>{{ ageDays }} dgn</dd>
            </div>
            <div *ngIf="formatMotherAnimalId(info.moederLandcode, info.moederLevensnummer, info.moederWerknummer) as motherId">
              <dt>Moeder</dt>
              <dd>{{ motherId }}</dd>
            </div>
            <div *ngIf="formatRvoDisplayDate(info.datumLaatsteMutatieDierkenmerken)">
              <dt>Laatste mutatie</dt>
              <dd>{{ formatRvoDisplayDate(info.datumLaatsteMutatieDierkenmerken) }}</dd>
            </div>
          </dl>
        </div>

        <section class="verblijf-section">
          <div class="verblijf-section__header">
            <h3>Verblijfplaatsen</h3>
            <button
              *ngIf="verblijfPlaatsen.length > 0"
              type="button"
              class="route-btn"
              (click)="openRouteMap()"
            >
              <fa-icon [icon]="['fal', 'map']"></fa-icon>
              Bekijk route
            </button>
          </div>

          <tcc-mono-rvo-verblijfplaatsen-timeline
            [places]="verblijfPlaatsen"
            [dierEinddatum]="info.dierEinddatum"
            [dierRedenEinde]="info.dierRedenEinde"
            (mapClicked)="onMapClicked($event)"
          ></tcc-mono-rvo-verblijfplaatsen-timeline>
        </section>
      </ng-container>

      <section *ngIf="hasErpData" class="erp-section">
        <button type="button" class="erp-toggle" (click)="toggleErp()">
          <span>ERP-gegevens</span>
          <fa-icon [icon]="['fal', erpExpanded ? 'chevron-up' : 'chevron-down']"></fa-icon>
        </button>

        <div *ngIf="erpExpanded" class="erp-content">
          <ion-list class="details-list" lines="full">
            <ion-list-header *ngIf="animalData?.ride" class="section-header ride">
              <ion-label>Rit</ion-label>
            </ion-list-header>
            <ng-container *ngIf="animalData?.ride">
              <ion-item class="kv-item">
                <ion-label>Ritnummer</ion-label>
                <ion-note slot="end">{{ animalData.ride?.number }}</ion-note>
              </ion-item>
              <ion-item class="kv-item">
                <ion-label>Kenteken</ion-label>
                <ion-note slot="end">{{ animalData.ride?.license_plate || '-' }}</ion-note>
              </ion-item>
              <ion-item class="kv-item">
                <ion-label>Bestemming UBN</ion-label>
                <ion-note slot="end">{{ animalData.ride?.destination_ubn || '-' }}</ion-note>
              </ion-item>
            </ng-container>

            <ion-list-header *ngIf="animalData?.ride_animal" class="section-header ride-animal">
              <ion-label>Rit dier</ion-label>
            </ion-list-header>
            <ng-container *ngIf="animalData?.ride_animal">
              <ion-item class="kv-item">
                <ion-label>Laden UBN</ion-label>
                <ion-note slot="end">{{ animalData.ride_animal?.loading_ubn || '-' }}</ion-note>
              </ion-item>
              <ion-item class="kv-item">
                <ion-label>Geslacht</ion-label>
                <ion-note slot="end">{{ animalData.ride_animal?.gender_name || '-' }}</ion-note>
              </ion-item>
              <ion-item class="kv-item">
                <ion-label>Kleur</ion-label>
                <ion-note slot="end">{{ animalData.ride_animal?.color_name || '-' }}</ion-note>
              </ion-item>
            </ng-container>

            <ion-list-header *ngIf="animalData?.purchase_order" class="section-header purchase-order">
              <ion-label>Inkooporder</ion-label>
            </ion-list-header>
            <ng-container *ngIf="animalData?.purchase_order">
              <ion-item class="kv-item">
                <ion-label>Ordernummer</ion-label>
                <ion-note slot="end">{{ animalData.purchase_order?.order_number }}</ion-note>
              </ion-item>
              <ion-item class="kv-item">
                <ion-label>Relatie</ion-label>
                <ion-note slot="end">{{ animalData.purchase_order?.relation_name || '-' }}</ion-note>
              </ion-item>
            </ng-container>

            <ion-list-header *ngIf="animalData?.animal" class="section-header animal">
              <ion-label>Ingekocht dier</ion-label>
            </ion-list-header>
            <ng-container *ngIf="animalData?.animal">
              <ion-item class="kv-item">
                <ion-label>Werknummer</ion-label>
                <ion-note slot="end">{{ animalData.animal?.work_number || '-' }}</ion-note>
              </ion-item>
            </ng-container>

            <ion-list-header *ngIf="animalData?.transport_group" class="section-header transport-group">
              <ion-label>Transportgroep</ion-label>
            </ion-list-header>
            <ng-container *ngIf="animalData?.transport_group">
              <ion-item class="kv-item" *ngIf="animalData.transport_group?.hub_name">
                <ion-label>Hub</ion-label>
                <ion-note slot="end">{{ animalData.transport_group?.hub_name }}</ion-note>
              </ion-item>
            </ng-container>
          </ion-list>
        </div>
      </section>
    </ng-container>
  </div>

  <div slot="left-buttons">
    <ion-button mode="ios" fill="clear" color="medium" (click)="close()">
      Sluiten
    </ion-button>
  </div>
</tcc-mono-dialog-layout>
